var $a8ee33871b41ed34$exports = {};
$a8ee33871b41ed34$exports = {
    "clear": `Wyczy\u{15B}\u{107}`,
    "invalid": `(nieprawid\u{142}owy)`,
    "loading": `Trwa \u{142}adowanie...`,
    "noResults": `Brak wynik\xf3w`,
    "valid": `(wa\u{17C}ny)`
};


export {$a8ee33871b41ed34$exports as default};
//# sourceMappingURL=pl-PL.module.js.map
